<div class="wrapper-dialog">
    <div class="header-dialog">
    <h1 mat-dialog-title>{{data.title}}</h1>
        <img (click)="onCancel()" src="./assets/images/icon-close.png" alt="close" height="12" width="12">
    </div>
    <div mat-dialog-content>
        <div class="d-flex align-items-center">
            <img *ngIf="data.action == 'success'" src="./assets/images/icon-circle-success.png" alt="circle success" height="24" width="24">
            <img *ngIf="data.action == 'warning'" src="./assets/images/icon-circle-warning.png" alt="circle warning" height="24" width="24">
            <img *ngIf="data.action == 'fail'" src="./assets/images/icon-circle-fail.png" alt="circle fail" height="24" width="24">
            <div *ngIf="data.action != 'delete'" style="width: 10px;"></div>
            <span>{{data.message}}</span>
        </div>
    </div>
    <!-- <hr *ngIf="data.hasBtn"> -->
    <div class="action-dialog" *ngIf="data.hasBtn && data.action != 'delete'" mat-dialog-actions>
        <button *ngIf="data.multiBtn" class="btn btn-outline-normal" mat-button (click)="onCancel()">ยกเลิก</button>
        <button class="btn btn-primary ml-2" mat-button (click)="onConfirm()">ตกลง</button>
    </div>
    <div class="action-dialog" *ngIf="data.hasBtn && data.action == 'delete'" mat-dialog-actions>
        <button class="btn btn-danger" mat-button (click)="onConfirm()">ลบ</button>
    </div>
</div>